export const css = {
    root: '_8jLeifg7',
    splash: '_1CnYW8yD',
    ' _key': 'lcc-app/splash'
};
export default css;
